<template>
    <div class="slider">
        <input type="range" min="0" :max="max" class="slider__input" :value="value" @input="onInput">
        <div class="slider__thumb" :style="rangeThumbPosition"></div>
    </div>
</template>

<script>
    export default {
        name: "Slider",

        props: {
            value: {},
            max: {
                default: 100,
            },
        },

        computed: {
            rangeThumbPosition() {
                return 'left:' + (this.value / this.max) * 100 + '%;';
            },
		},
		
        methods: {
            onInput(event) {
                this.$emit('input', event);
            }
        }
    }
</script>